import {createI18n} from 'vue-i18n';

const messages = {
  en: {
    menu: {
      home: 'Home', sign_in: 'Sign In', cabinet: 'Cabinet',
    },

    home: {
      line_1_title: 'RESTful API',
      line_1_subtitle: 'Integrate effortlessly with your existing systems.',
      line_2_title: 'Manage data',
      line_2_subtitle: 'Retrieve and submit EBICS orders, schedule executions, analyze historical data.',
      line_3_title: 'Intuitive UI',
      line_3_subtitle: 'Easily integrate your banks into internal workflows.',
      line_4_title: 'Standalone Deployment',
      line_4_subtitle: 'Deploy the service as a secure, self-contained Docker microservice.',
      start_btn: 'Start with Ebics API',
    },

    sign_in: {
      title: 'Sign In',
      line_1: 'Use dashboard to control access',
      github_btn: 'GitHub sign in',
      openid_btn: 'OpenId sign in',
    },

    fetch: {
      authorize: 'Authorize by {name}',
    },
  },

  de: {
    menu: {
      home: 'Startseite', sign_in: 'Anmelden', cabinet: 'Kabinett',
    },

    home: {
      line_1_title: 'RESTful API',
      line_1_subtitle: 'Integrieren Sie sich mühelos in Ihre bestehenden Systeme.',
      line_2_title: 'Daten verwalten',
      line_2_subtitle: 'Abrufen und Übermitteln von EBICS-Aufträgen, Ausführungen planen und historische Daten analysieren.',
      line_3_title: 'Intuitive Benutzeroberfläche',
      line_3_subtitle: 'Integrieren Sie Ihre Banken einfach in interne Arbeitsabläufe.',
      line_4_title: 'Eigenständige Bereitstellung',
      line_4_subtitle: 'Stellen Sie den Dienst als sicheren, eigenständigen Docker-Mikroservice bereit.',
      start_btn: 'Starten Sie mit der Ebics API',
    },

    sign_in: {
      title: 'Anmelden',
      line_1: 'Verwenden Sie das Dashboard, um den Zugriff zu steuern',
      github_btn: 'Mit GitHub anmelden',
      openid_btn: 'Mit OpenId anmelden',
    },

    fetch: {
      authorize: 'Autorisieren durch {name}',
    },
  },

  fr: {
    menu: {
      home: 'Accueil', sign_in: 'Connexion', cabinet: 'Cabinet',
    },

    home: {
      line_1_title: 'API RESTful',
      line_1_subtitle: 'Intégrez-vous facilement à vos systèmes existants.',
      line_2_title: 'Gérer les données',
      line_2_subtitle: 'Récupérez et soumettez des ordres EBICS, planifiez des exécutions, analysez les données historiques.',
      line_3_title: 'Interface intuitive',
      line_3_subtitle: 'Intégrez facilement vos banques dans les flux de travail internes.',
      line_4_title: 'Déploiement autonome',
      line_4_subtitle: 'Déployez le service comme un microservice Docker sécurisé et autonome.',
      start_btn: 'Commencer avec l`API Ebics',
    },

    sign_in: {
      title: 'Se connecter',
      line_1: 'Utilisez le tableau de bord pour contrôler l`accès',
      github_btn: 'Se connecter avec GitHub',
      openid_btn: 'Se connecter avec OpenId',
    },

    fetch: {
      authorize: 'Autoriser par {name}',
    },
  },
};

export default createI18n({locale: 'en', fallbackLocale: 'en', messages, legacy: false, globalInjection: false});
